import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardHeader from 'components/Card/CardHeader.js';
import Button from '@mui/material/Button';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Alert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import RefreshIcon from '@mui/icons-material/Refresh';
import TablaUsuarios from 'views/Grillas/UsuariosGrilla';
import RolesUsuariosGrilla from 'views/Grillas/RolesUsuariosGrilla';

function Usuarios() {
  const [selectedRol, setSelectedRol] = useState('');
  const [selectedObjeto, setSelectedObjeto] = useState('');
  const [valoresLista, setValoresLista] = useState([]);
  const [showErrorAlert, setShowErrorAlert] = useState(false);

  const loadvaloreslista = async () => {
    try {
      const seleccion = await fetch(`${process.env.REACT_APP_API_URL}/usuarios`, {
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('token'),
        },
      });
      const seleccionjson = await seleccion.json();
      setValoresLista(seleccionjson);
      if (seleccionjson.length > 0) {
        setSelectedRol(seleccionjson[0].usr_codigo);
      }
    } catch (err) {
      console.error('Error al obtener datos:', err.message);
    }
  };

  useEffect(() => { loadvaloreslista(); }, []);

  const GuardarCambios = async () => {
    try {
      const numeros = Object.keys(selectedObjeto);
      await fetch(`${process.env.REACT_APP_API_URL}/usuariosxroles/` + selectedRol, {
        method: 'delete',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('token'),
        },
      });
      numeros.map(numero => {
        fetch(`${process.env.REACT_APP_API_URL}/usuariosxroles`, {
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('token'),
          },
          body: JSON.stringify({
            usr_codigo: selectedRol,
            rol_codigo: numero,
          }),
        });
      });
      setShowErrorAlert(true);
      setTimeout(() => { setShowErrorAlert(false); }, 1000);
    } catch (err) {
      console.error('Error al guardar roles xobjetos:', err.message);
    }
  };

  const manejarDatoDesdeHijo = (dato) => {
    setSelectedObjeto(dato);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', pt: '120px' }}>
      <Card>
        <CardHeader>
          <Typography variant="h6" fontWeight="bold" color="text.primary">
            Usuarios del Sistema
          </Typography>
          <Divider sx={{ mt: 1 }} />
        </CardHeader>
        <CardBody>
          <Grid container spacing={3} sx={{ mb: 2 }}>

            {/* Columna izquierda — lista de usuarios */}
            <Grid item xs={12} md={6}>
              <Card sx={{ minHeight: 125 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                  <TablaUsuarios />
                </Box>
              </Card>
            </Grid>

            {/* Columna derecha — asignación de roles */}
            <Grid item xs={12} md={6}>
              <Card sx={{ minHeight: 125 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                  <Typography variant="subtitle1" fontWeight="bold" color="text.primary">
                    Rol x Usuarios
                  </Typography>

                  {/* Selector de usuario + botón refresh */}
                  <Card>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={10}>
                        <FormControl fullWidth size="small">
                          <InputLabel>Usuario</InputLabel>
                          <Select
                            value={selectedRol}
                            label="Usuario"
                            onChange={(e) => setSelectedRol(e.target.value)}
                          >
                            {valoresLista.map((dpto) => (
                              <MenuItem key={dpto.usr_codigo} value={dpto.usr_codigo}>
                                {dpto.usr_descripcion}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={2}>
                        <IconButton onClick={loadvaloreslista} size="small" color="primary">
                          <RefreshIcon />
                        </IconButton>
                      </Grid>
                    </Grid>
                  </Card>

                  {/* Botón guardar + alerta */}
                  <Card>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                      <Button
                        variant="contained"
                        size="small"
                        onClick={GuardarCambios}
                        sx={{ fontWeight: 'bold' }}
                      >
                        GUARDAR
                      </Button>
                      <Collapse in={showErrorAlert}>
                        <Alert severity="success" sx={{ py: 0 }}>
                          Se actualizó el Usuario
                        </Alert>
                      </Collapse>
                    </Box>
                    <RolesUsuariosGrilla
                      valorParaHijo={selectedRol}
                      onEnviarDato={manejarDatoDesdeHijo}
                    />
                  </Card>

                </Box>
              </Card>
            </Grid>

          </Grid>
        </CardBody>
      </Card>
    </Box>
  );
}

export default Usuarios;
